import { useTranslation } from "react-i18next";
import { Button } from "component-library";
import { XCircleIcon } from "@heroicons/react/16/solid";

export const ErrorPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <XCircleIcon className="w-16 h-16 text-error mb-4" />
      <div className="flex flex-col items-center justify-center gap-5">
        <div className="text-xl text-text-primary text-center">
          {t("pages.error.title")}
        </div>
        <div className="text-center text-gray-700">
          {t("pages.error.text_part_one")}
        </div>
        <span className="text-center text-gray-700 mb-4">
          {t("pages.error.text_part_two")}
        </span>

        <Button variant="outlined" onClick={() => window.location.reload()}>
          {t("pages.error.submit")}
        </Button>
      </div>
    </div>
  );
};
